export enum DataverseViewEnum {
  None,
  BusinessView,
  DevelopmentView,
  KeyUserView
}
